import React from 'react';
import _ from 'lodash';

import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from 'redux-form';
import classNames from 'classnames';

import {
  createOffer,
  selectOffers,
  fetchCreateOfferWarnings
} from 'ducks/bookings/detail';
import {MODALS} from 'ducks/bookings';

import {storeDataInModal, selectModal} from 'ducks/modals';
import ErrorBlock from 'components/ErrorBlock';
import Warning from 'components/Warning';

import {formatDateForApi, formatDate} from 'utils/datetime';

import {OfferSection, BreakClauseSection} from './components';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {startDate, endDate, roomDeposit, pwRent, breakClause} = values;
  const booking = props.bookingId;
  if (breakClause) {
    breakClause.isFlexible = breakClause.type === 'flexible';
  }

  const data = {
    startDate: formatDateForApi(startDate),
    endDate: formatDateForApi(endDate),
    roomDeposit,
    pwRent,
    breakClause,
    booking
  };

  const extraActions = props.getExtraActions();
  dispatch(createOffer(data, extraActions));
};

class CreateOfferForm extends React.Component<any> {
  componentDidMount() {
    const {bookingId} = this.props;

    const extraActions = [
      data =>
        storeDataInModal({
          modalName: MODALS.CREATE_OFFER,
          data: {createWarnings: data.warnings}
        })
    ];
    this.props.fetchCreateOfferWarnings({bookingId}, extraActions);
  }

  onIncludeBreakClauseChange = () => {
    const {clearFields, form} = this.props;
    clearFields(
      form,
      false,
      false,
      'breakClause.periodMonths',
      'breakClause.noticePeriodMonths',
      'breakClause.type'
    );
  };

  render() {
    const {
      className,
      handleSubmit,
      error,
      includeBreakClause,
      createWarnings
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'CreateOfferForm')}>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        {createWarnings &&
          createWarnings.map(warning => (
            <Warning key={warning}>{warning}</Warning>
          ))}
        <OfferSection />
        <div className="offerDivider" />
        <BreakClauseSection
          onIncludeBreakClauseChange={this.onIncludeBreakClauseChange}
          includeBreakClause={includeBreakClause}
        />
      </form>
    );
  }
}

const selector = formValueSelector('createBookingOffer');

const mapStateToProps = state => {
  const offers = selectOffers(state);
  let startDate: any = null;
  let endDate: any = null;
  let pwRent: any = null;
  let roomDeposit: any = null;

  if (!_.isEmpty(offers)) {
    const lastOffer: any = _.last(offers);
    startDate = formatDate(lastOffer.startDate);
    endDate = formatDate(lastOffer.endDate);
    pwRent = lastOffer.pwRent;
    roomDeposit = lastOffer.roomDeposit;
  }

  const {data: {createWarnings}} = selectModal(state, MODALS.CREATE_OFFER);

  return {
    includeBreakClause: selector(state, 'includeBreakClause'),
    initialValues: {
      startDate,
      endDate,
      roomDeposit,
      pwRent
    },
    createWarnings
  };
};

const mapDispatchToProps = {
  fetchCreateOfferWarnings
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({form: 'createBookingOffer', onSubmit: formSubmit})(CreateOfferForm)
);
